import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { SCHEDULE_LEGEND_ITEMS } from './scheduleColors';

function LegendSwatch({ color }) {
  return (
    <Box
      aria-hidden
      sx={{
        width: 12,
        height: 12,
        borderRadius: 0.5,
        bgcolor: color,
        border: '1px solid',
        borderColor: 'divider',
        flexShrink: 0,
      }}
    />
  );
}

export default function ScheduleColorLegend({ viewMode = 'calendar' }) {
  const items = SCHEDULE_LEGEND_ITEMS[viewMode] || SCHEDULE_LEGEND_ITEMS.calendar;

  return (
    <Box
      sx={{
        mb: 1.5,
        py: 1,
        px: 1.25,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'grey.50',
      }}
    >
      <Stack direction="row" flexWrap="wrap" useFlexGap spacing={1.5} rowGap={1}>
        {items.map((item) => (
          <Stack key={item.label} direction="row" alignItems="center" spacing={0.75}>
            <LegendSwatch color={item.color} />
            <Typography variant="caption" color="text.secondary">
              {item.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
